import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable()
export class UnifiedRegistrationApiService {
  constructor(private http: HttpClient) { }

  createTester(reg: any): Observable<any> {
    return this.http.post('/api/v1/users', reg).pipe(map((r: any) => r?.data ?? r));
  }

  getCountries(): Observable<Array<{ id: number; name: string; code?: string }>> {
    return this.http.get('/api/v1/static_values/countries').pipe(map((r: any) => r?.data ?? r));
  }

  getStates(countryId: number | string): Observable<Array<{ id: number; name: string }>> {
    return this.http.get('/api/v1/static_child_values', { params: { key: 'State', parent_id: countryId } })
      .pipe(map((r: any) => r?.data ?? r));
  }

  getYears(): number[] {
    const d = new Date();
    const years: number[] = [];
    for (let i = d.getFullYear() - 18; i > d.getFullYear() - 150; i--) years.push(i);
    return years;
  }

  getMonths(year?: number): Array<{ id: number; name: string }> {
    const allMonths = [
      { id: 1, name: 'January' },
      { id: 2, name: 'February' },
      { id: 3, name: 'March' },
      { id: 4, name: 'April' },
      { id: 5, name: 'May' },
      { id: 6, name: 'June' },
      { id: 7, name: 'July' },
      { id: 8, name: 'August' },
      { id: 9, name: 'September' },
      { id: 10, name: 'October' },
      { id: 11, name: 'November' },
      { id: 12, name: 'December' },
    ];
    const eighteenYearsAgo = new Date().getFullYear() - 18;
    if (year && year === eighteenYearsAgo) return allMonths.slice(0, new Date().getMonth() + 1);
    return allMonths;
  }

  getDays(month?: number, year?: number): number[] {
    const y = year || new Date().getFullYear();
    const m = month || 1;
    const numberOfDays = new Date(y, m, 0).getDate();
    return Array.from({ length: numberOfDays }, (_v, i) => i + 1);
  }

  getUtmCampaignFromLocation(): any[] | undefined {
    const params = new URLSearchParams(window.location.search);
    const utm: any = {};
    if (params.get('utm_campaign')) utm.utmCampaign = params.get('utm_campaign');
    if (params.get('utm_source')) utm.utmSource = params.get('utm_source');
    if (params.get('utm_medium')) utm.utmMedium = params.get('utm_medium');
    if (params.get('utm_content')) utm.utmContent = params.get('utm_content');
    if (params.get('utm_term')) utm.utmTerm = params.get('utm_term');
    return Object.keys(utm).length ? [utm] : undefined;
  }

  resendConfirmationEmail(email: string): Observable<any> {
    return this.http.post('/api/v1/users/resend_confirmation_email', { email });
  }

  getUserInfoByCode(userCode: string): Observable<{ name: string; email: string }> {
    return this.http.get(`/api/v1/users/user_info_by_code?code=${userCode}`).pipe(map((r: any) => r?.data ?? r));
  }
}
